<template>
    <div class="content-ent">
        <div style="width:16%;height:100%;position: relative;background: #fff;padding:1vh;">
            <el-tree
            :data="dataTree"
            ref="tree"
            :props="defaultProps"
            default-expand-all
            :expand-on-click-node="false"
            :highlight-current="true"
            @node-click="handleNodeClick"
            node-key="id"
            :current-node-key="currentNodekey"
            :default-expanded-keys="expandedkeys"
          > 
            <span class="span-ellipsis" slot-scope="{ node, data }" style="width: 100%;text-align: left;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
              <span :title="node.label" class="">{{data.name}}</span>
            </span>
          </el-tree>
        </div>
        <div style="position: relative;width: 84%;height:100%;padding-left:1vh;">
            <div class="box-contain" style="width:100%;height:calc( 100% - 6vh );position: relative;background: #ecf0f5;overflow: auto;">
                <div class="box-item" v-for="(item,index) in monitorList" :key="index">
                    <div class="item-monitor">
                        <iframe width="100%" height="100%" :src='item.showUrl' style="border: 0;height: 100%;"></iframe>
                    </div>
                    <div class="item-info">
                        <span v-if="!item.isEditName" class="name nowrap" @dblclick="changeName(item)">{{item.name}}</span>
                        <div v-if="item.isEditName" class="name" style="text-align: left;padding-left:1vh;">
                            <el-input  v-model="item.name" @change="saveName(item)" @clear="refrshName(item)"></el-input>
                        </div>
                        <img v-if="item.type=='1'" src="../../assets/image/gun.png" />
                        <img v-else-if="item.type=='2'" src="../../assets/image/ptz.png" />
                        <span style="margin-right: 1vw;cursor: pointer;" @click="toDetail(item)">操作</span>
                    </div>
                </div>
                <div v-if="monitorList.length==0" style="display: flex;justify-content: center;align-items: center;width: 100%;height: 100%;position: relative;">暂无数据</div>
            </div>
            <!-- 分页展示 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[3, 6, 12]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import myHttp from '../../untils/port';
import util from '../../untils/util';
export default {
    data(){
        return{
            groupId:'',
            joinType:'2',
            dataTree:[],
            defaultProps: {
                children: 'list',
                label: 'name'
            },
            expandedkeys:[],
            currentNodekey: '', //默认选中的节点树
            projectId:'',//当前项目id
            useType:'',
            name:'',
            currentPage: 1,
            pageSize: 6,
            totalItems: 0,
            ysToken:'',
            monitorList:[],
        }
    },
    mounted(){
        var that = this;
        // window.addEventListener('message', function(e){
        //     if(e.data.projectId){
        //         var opt = e.data;
        //         let routeUrl = that.$router.resolve({
        //             name: "monitorSign",
        //             params: {'id': opt.projectId,'type':opt.machType,'sn':opt.sn,'channel':opt.channelNo}
        //         });
        //         window.open(routeUrl .href, '_blank');
        //     }
        // })
        this.groupId = util.session.get('groupId')
        this.getYsToken()
        this.getTree()
    },
    methods:{
        //获取项目树
        getTree(){
            var that = this
            myHttp.getPageListPro({
                entId: this.groupId,
                joinType: this.joinType
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.entOfficeProjectMenu || []
                    for(var i=0;i<list.length;i++){
                        if(list[i].list.length>0 && that.projectId==''){
                            that.projectId = list[i].list[0].id
                            that.currentNodekey = list[i].list[0].id
                            // that.expandedkeys.push(list[i].list[0].id)
                            that.$nextTick(() => {
                            // treeBox 元素的ref   value 绑定的node-key
                                that.$refs.tree.setCurrentKey(that.currentNodekey)
                            })
                            if(that.ysToken && that.ysToken!=''){
                                that.getData()
                            }
                        }
                    }
                    that.dataTree = list
                }
            })
        },

        //获取token
        getYsToken(){
            var that = this
            myHttp.getYsToken({
              projectId: this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    that.ysToken = resp.data.data.accessToken||''
                    if(that.projectId && that.projectId!=''){
                        that.getData()
                    }
                    // that.getDevice()
                }
            })
        },

        handleSizeChange(val) {
            this.pageSize = val
            this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.currentChangePage()
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getData()
        },
        //监听选择
        doFilter(){
            this.getData()
        },

        //获取数据
        getData(){
            var that = this
            var that = this
            myHttp.getCameraPageListByProjectId({
                projectId:this.projectId,
                pageNum:this.currentPage,
                pageSize:this.pageSize,
                useType:this.useType,
                name:this.name
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.PageInfo.list||[];
                    for(var i=0;i<list.length;i++){
                        list[i].showUrl = '/monitor/view/one.html?serial='+list[i].serial+'&channel='+list[i].channelNo+'&token='+that.ysToken
                        list[i].isEditName = false
                    }
                    that.monitorList = list
                    that.totalItems = resp.data.data.PageInfo.total||0
                }
            })
        },

        //树形点击
        handleNodeClick(e){
            console.log(e)
            if(e.level!='1'){
                this.projectId = e.id
                this.currentPage = 1
                this.getData()
            }
        },

        toDetail(opt){
            // console.log(opt)
            // let routeUrl = this.$router.resolve({
            //     name: "monitorSign",
            //     params: {'id': this.projectId,'type':opt.machType,'sn':opt.serial,'channel':opt.channelNo}
            // });
            // window.open(routeUrl .href, '_blank');
            opt.machType = opt.machType?opt.machType:'1'
            this.$router.push('/monitorSign/'+this.projectId+'/'+opt.machType+'/'+opt.serial+'/'+opt.channelNo)
        },
    }
}
</script>
<style scoped>
    .content-ent{
        height: 100%;
        width: 100%;
        position: relative;
        display: flex;
    }
    .box-contain{
        width: 100%;
        height: calc( 100% - 13vh );
        position: relative;
        display: flex;
        flex-wrap: wrap;
        padding: 0 0.5vh;
        overflow: auto;
        align-content: flex-start;
    }
    .box-item{
        width:33.33%;
        height: 50%;
        position: relative;
        padding: 0 0.5vh 1vh;
    }
    .item-monitor{
        width: 100%;
        height: calc( 100% - 5vh );
        position: relative;
        background: #fff;
    }
    .item-info{
        width: 100%;
        height: 5vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: space-around;
        background: #fff;
    }
    .item-info .name{
        flex:1;
        text-align: center;
        
    }
    .item-info img{
        width:1.5vw;
        height: auto;
        position: relative;
        margin: 0 1vw;
    }
    .disabled{
        color:#409EFF;
        cursor: pointer;
    }
</style>